import {
  isEmptyString
} from "./chunk-NQ7GJGRO.js";

// src/utils/StringMethods.ts
import * as _ from "lodash";
function capitalizeFirst(str) {
  let firstLetter = str.charAt(0);
  let remainingLetters = str.substring(1);
  firstLetter = firstLetter.toUpperCase();
  remainingLetters = remainingLetters.toLowerCase();
  return firstLetter + remainingLetters;
}
function capitalizeAll(str) {
  const words = str.split(" ");
  words.forEach((word, index) => {
    words[index] = capitalizeFirst(word);
  });
  return words.join(" ");
}
function removeMasks(str) {
  return str.normalize("NFD").replace(/[ ~`!#@$%^&*()+={}\-[\];:'"<>.,\\/?_]/g, "");
}
function getLocaleFromCurrency(currency) {
  switch (currency) {
    case "BRL":
      return "pt-BR";
    case "EUR":
      return "en-US";
    case "USD":
      return "en-US";
    default:
      return "pt-BR";
  }
}
function formatCurrency(value, currency) {
  return new Intl.NumberFormat(getLocaleFromCurrency(currency), {
    style: "currency",
    currency: !currency || isEmptyString(currency) ? "BRL" : currency
  }).format(Number(!value || isEmptyString(value) ? 0 : value)).replace("\xA0", " ");
}
function formatToBrCurrency(value) {
  return !value || typeof value === "string" && isEmptyString(value) ? "-" : new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(Number(value)).replace("\xA0", " ");
}
function convertToBrCurrency(value) {
  if (!value) return "R$ 0,00";
  const currency = formatToBrCurrency(value);
  return currency === "-" ? "R$ 0,00" : currency;
}
function convertFromCurrency(value) {
  const numericValue = value.split(" ")[1].replace(".", "").replace(",", ".");
  return isNaN(Number(numericValue)) ? 0 : parseFloat(numericValue);
}
function convertToPercents(value) {
  const numericValue = Number(value);
  return isNaN(numericValue) ? "0.00%" : `${numericValue.toFixed(2)}%`;
}
function convertFromPercents(value) {
  const numericValue = value.slice(0, -1).trim();
  return isNaN(Number(numericValue)) ? 0 : parseFloat(numericValue);
}
function formatBrCurrencyToNumber(str) {
  return !isEmptyString(str) ? Number(str.split("R$")[1].trim().replace(/\./g, "").replace(",", ".")) : 0;
}
function removeAccents(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036F]/g, "");
}
function toSnakeUpperCase(str) {
  return _.snakeCase(str).toUpperCase();
}

export {
  capitalizeFirst,
  capitalizeAll,
  removeMasks,
  getLocaleFromCurrency,
  formatCurrency,
  formatToBrCurrency,
  convertToBrCurrency,
  convertFromCurrency,
  convertToPercents,
  convertFromPercents,
  formatBrCurrencyToNumber,
  removeAccents,
  toSnakeUpperCase
};
//# sourceMappingURL=chunk-VZX3AJYE.js.map